/**
 * "Mute videos forever": a per-browser preference honoured by every slide surface (editor, present mode,
 * shared view). Stored in localStorage; components subscribe through useVideosMuted().
 */
import { useEffect, useState } from 'react';

const KEY = 'cowork_videos_muted';
const EVENT = 'cowork-videos-muted';

export function videosMuted(): boolean {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}
export function setVideosMuted(muted: boolean): void {
  try { localStorage.setItem(KEY, muted ? '1' : '0'); } catch { /* private mode */ }
  window.dispatchEvent(new CustomEvent(EVENT, { detail: muted }));
}
export function useVideosMuted(): [boolean, (muted: boolean) => void] {
  const [muted, setMuted] = useState<boolean>(() => videosMuted());
  useEffect(() => {
    const on = (e: Event) => setMuted(!!(e as CustomEvent<boolean>).detail);
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return [muted, setVideosMuted];
}
